import { TableCell, TableRow, Typography } from '@mui/material';

export default function InPersonEventParticipant({ participant }) {
	return (
		<TableRow hover>
			<TableCell>
				<Typography variant="body2">{participant.first_name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{participant.last_name}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{participant.city}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="body2">{participant.age}</Typography>
			</TableCell>
		</TableRow>
	);
}
